const language = 'fr';
export const langDir = 'ltr';

export default language;
